import React from "react";
const { __ } = wp.i18n;
import { decode } from "html-entities";

const NewsList = ({ posts, spinner, newsSize }) => {
  return (
    <>
      {spinner && (
        <div className="news-block__spinner" aria-hidden="true"></div>
      )}
      {posts && !spinner && (
        <ul
          className={`news-block__list  ${
            newsSize === "normal" ? "news-block__list--full" : ""
          }`}
        >
          {posts.map((post) => {
            return (
              <li key={post?.id} className="news-block__item">
                {post?.thumbnailUrl && (
                  <div className="news-block__thumbnail">
                    <img
                      className="news-block__image"
                      src={post.thumbnailUrl}
                      alt={post.thumbnailAlt}
                    />
                  </div>
                )}
                {post?.link && post?.title && (
                  <a href={post.link} className="news-block__link">
                    <h3 className="news-block__item-title">
                      {decode(post.title)}
                    </h3>
                  </a>
                )}
                {post?.date && newsSize === "normal" && (
                  <div className="news-block__date-info">
                    <span className="news-block__published">
                      {__("Published on", "efdc")}
                    </span>
                    <span className="news-block__date">{post.date}</span>
                  </div>
                )}
                {post?.excerpt && (
                  <div dangerouslySetInnerHTML={{ __html: post.excerpt }}></div>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};

export default NewsList;
